import React from 'react';
import styles from './HeaderBar.css';

const HeaderButton = ({ children, onClick, label }) => (
    <div className={styles.menuButtonDiv} onClick={onClick}>
        {label || children || ''}
    </div>
);

export default HeaderButton;
